import { createContext, useContext, useState, ReactNode, useMemo } from 'react'

interface XRayAnnotations {
  [key: string]: string // key é o identificador da imagem/exame
}

interface XRayAnnotationsContextType {
  annotations: XRayAnnotations
  addAnnotation: (imageId: string, annotation: string) => void
  clearAnnotations: () => void
  getAnnotation: (imageId: string) => string
}

const XRayAnnotationsContext = createContext<
  XRayAnnotationsContextType | undefined
>(undefined)

interface XRayAnnotationsProviderProps {
  children: ReactNode
}

export const XRayAnnotationsProvider = ({
  children
}: XRayAnnotationsProviderProps) => {
  const [annotations, setAnnotations] = useState<XRayAnnotations>({})

  const addAnnotation = (imageId: string, annotation: string) => {
    setAnnotations(prev => {
      const newAnnotations = {
        ...prev,
        [imageId]: annotation
      }
      return newAnnotations
    })
  }

  const clearAnnotations = () => {
    setAnnotations({})
  }

  const getAnnotation = (imageId: string): string => {
    return annotations[imageId] || ''
  }

  const value = useMemo(
    () => ({ annotations, addAnnotation, clearAnnotations, getAnnotation }),
    [annotations]
  )

  return (
    <XRayAnnotationsContext.Provider value={value}>
      {children}
    </XRayAnnotationsContext.Provider>
  )
}

export const useXRayAnnotations = () => {
  const context = useContext(XRayAnnotationsContext)
  if (!context) {
    throw new Error(
      'useXRayAnnotations must be used within XRayAnnotationsProvider'
    )
  }
  return context
}
